import { useTranslation } from 'react-i18next'
import { useDarkMode } from '../../hooks/useDarkMode'
import LanguageSelector from '../../components/LanguageSelector'
import { trackEvent } from '../../lib/analytics'

export default function Header() {
  const { t } = useTranslation()
  const { isDark, toggle } = useDarkMode()

  return (
    <header className="pt-8 pb-6 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Theme Toggle + Language Selector */}
        <div className="flex justify-end items-center gap-2 mb-4">
          <LanguageSelector />
          <button
            onClick={() => { toggle(); trackEvent('theme_toggle', { theme: isDark ? 'light' : 'dark' }) }}
            aria-label="Toggle Theme"
            className="p-2 rounded-full hover:bg-slate-200 dark:hover:bg-slate-800 transition-colors flex items-center justify-center text-neonBlue"
          >
            {isDark ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <circle cx="12" cy="12" r="5" fill="currentColor" stroke="none" />
                <path strokeLinecap="round" d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
              </svg>
            )}
          </button>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="text-center md:text-left">
            <h1 className="text-6xl md:text-8xl font-black tracking-tighter uppercase italic leading-none">
              <span className="text-neonBlue">{t('header.titleLine1')}</span>
              <br />
              <span className="text-neonPink">{t('header.titleLine2')}</span>
            </h1>
            <p className="mt-4 text-xl md:text-2xl font-bold text-slate-500 dark:text-slate-300">
              {t('header.subtitle')}
            </p>
          </div>

          {/* Mascot */}
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-neonBlue to-neonPink rounded-full blur opacity-30 group-hover:opacity-80 transition duration-1000 group-hover:duration-200" />
            <img
              src="/mascot.webp"
              alt={t('header.mascotAlt')}
              width={256}
              height={256}
              fetchPriority="high"
              className="relative w-48 h-48 md:w-64 md:h-64 object-contain glitch-hover cursor-pointer drop-shadow-[0_0_15px_rgba(59,59,255,0.3)]"
            />
          </div>
        </div>
      </div>
    </header>
  )
}
